(ns quuppa.qsm.permissions
  (:require [re-frame.core :as rf]
            [quuppa.qsm.subs :as qsm-subs]))

(defn is-qsm-owner? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "owner")))

(defn is-qsm-admin? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "admin")))

(defn is-qsm-member? []
  (let [session-user @(rf/subscribe [::qsm-subs/user])
        user-role (first (:roles session-user))]
    (= user-role "member")))

(defn user-in-qsm-domain? []
  (or (is-qsm-owner?)
      (is-qsm-admin?)
      (is-qsm-member?)))

(defn has-manage-permission? []
  (or (is-qsm-owner?)
      (is-qsm-admin?)))

(defn has-manage-permission-to-resource? [resource]
  (some #{(:resource-role resource)} ["owner" "admin"]))
